import { fetchUserPassportAPI } from "@/modules/common/api/index.v2";
import useAuth from "@/modules/common/hooks/auth.hook";
import useLocalStorageState from "@/modules/common/hooks/local-storage.hook";
import { createContext, ReactNode, useEffect } from "react";
import { Permission, WhatsappInstance } from "@/modules/common/types";
import { useQuery } from "@tanstack/react-query";

type NawyPassportProviderProps = {
  children: ReactNode;
};

export type NawyPassportState = {
  permissions: Permission[];
  whatsappInstance: WhatsappInstance | null;
};

const initialState: NawyPassportState = {
  permissions: [],
  whatsappInstance: null,
};

export const NawyPassportContext = createContext(initialState);

const NawyPassportProvider = ({ children }: NawyPassportProviderProps) => {
  const { user } = useAuth();

  const [passport, setPassport] = useLocalStorageState(
    "passport",
    initialState,
  );

  const { data: userPassport, error } = useQuery({
    queryKey: ["userPassport", user?.sub],
    queryFn: async () => {
      const response = await fetchUserPassportAPI();
      return response.data;
    },
    enabled: !!user,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });

  useEffect(() => {
    if (userPassport) {
      setPassport({
        permissions: userPassport.permissions,
        whatsappInstance: userPassport.whatsappInstance ?? null,
      });
    } else if (error) {
      // TODO logout user
      setPassport(initialState);
    }
  }, [userPassport, error, setPassport]);

  return (
    <NawyPassportContext.Provider value={passport}>
      {children}
    </NawyPassportContext.Provider>
  );
};

export default NawyPassportProvider;
